"use strict";

(function () {
  var form = document.querySelector("form.cart");
  var btnSubmit = form.querySelector("input[type=submit][name=checkout]");
  var stepBtn = form.querySelector("[step-btn]");
  var locale = window.Shopify.locale;

  if (!btnSubmit) {
    return;
  }

  var btnValue = btnSubmit.value;

  btnSubmit.addEventListener("click", function (e) {
    e.preventDefault();
    if (hasClass(e.target, "btn--disabled")) {
      return;
    }
    addClass(e.target, "btn--disabled");
    e.target.value = `${locale === "ro" ? "Procesare comenzii" : "Оформление"}`;
    placeOrder();
  });

  var emailInput = document.querySelector("#delivery-form-email");
  // emailInput.addEventListener("keyup", function (e) {
  //   validateEmailInput(e.target);
  // });
  // emailInput.addEventListener("blur", function (e) {
  //   e.target.dataset.blurredOnce = true;
  //   validateEmailInput(e.target);
  // });

  var inputs;
  var customCheckboxes = Array.from(form.querySelectorAll(".custom-cbx"));

  customCheckboxes.forEach(function (chk) {
    chk.addEventListener("change", function () {
      initCheckoutLiveValidation();
      togglePlaceOrderBtn();
    });
  });

  initCheckoutLiveValidation();

  function initCheckoutLiveValidation() {
    inputs = Array.from(
      form.querySelectorAll("#step-2 input:required, #step-3 input:required")
    );
    inputs.forEach(function (input) {
      input.removeEventListener("keyup", togglePlaceOrderBtn);
      input.addEventListener("keyup", togglePlaceOrderBtn);
    });
  }

  function togglePlaceOrderBtn() {
    if (!validateCheckout()) {
      btnSubmit.disabled = true;
      addClass(btnSubmit, "btn--disabled");

      stepBtn.disabled = true;
      addClass(stepBtn, "btn--disabled");
    } else {
      btnSubmit.disabled = false;
      removeClass(btnSubmit, "btn--disabled");

      stepBtn.disabled = false;
      removeClass(stepBtn, "btn--disabled");
    }
  }

  function placeOrder() {
    var urlShopify = window.Shopify.routes.root;

    if (!validateCheckoutDetails()) {
      switchSubmitBtnToDefaultState();
      return;
    }
    hideCheckoutError();
    fetch(urlShopify + "cart.js")
      .then(function (res) {
        return res.json();
      })
      .then(function (cart) {
        var data = prepareOrderData();
        data.cart = prepareCart(cart);

        return fetch("/a/bypass-checkout/place-order", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(data),
        });
      })
      .then(function (res) {
        return res.json();
      })
      .then(function (res) {
        if (res.success) {
          fetch(urlShopify + "cart/clear").then(function () {
            // location.href = res.order_status_url;
            location.href = urlShopify + "pages/thank-you";
          });
        } else if ("msg" in res) {
          showCheckoutError(res.msg);
          switchSubmitBtnToDefaultState();
        } else {
          showCheckoutError("Непредвиденная ошибка");
          switchSubmitBtnToDefaultState();
        }
      })
      .catch(function () {
        alert("Unexpected error");
        showCheckoutError("Непредвиденная ошибка");
        switchSubmitBtnToDefaultState();
      });
  }

  function validateCheckoutDetails() {
    var errors = [];

    Array.from(form.querySelectorAll("input[required]")).forEach(function (
      input
    ) {
      var val = input.value;
      if (!trim(val).length) {
        errors.push(
          "- " + input.getAttribute("placeholder").replace(/\*$/, "")
        );
        addClass(input, "error");
      } else {
        removeClass(input, "error");
      }
    });

    if (errors.length) {
      alert(
        "Следующие поля обязательны для заполнения:\n\n" + errors.join("\n")
      );
      return false;
    }

    return true;
  }

  /**
   * Prepare cart items for POST request. Remove all the unnecessary properties.
   * @param cart
   * @returns {*}
   */
  function prepareCart(cart) {
    const postAttributes = ["variant_id", "quantity"];
    for (let i = 0; i < cart.items.length; i++) {
      let item = cart.items[i];
      for (let k in item) {
        if (item.hasOwnProperty(k)) {
          if (postAttributes.indexOf(k) < 0) {
            delete item[k];
          }
        }
      }
      cart.items[i] = item;
    }
    return cart;
  }

  function prepareOrderData() {
    var data = {};
    data.first_name = trim(form.querySelector("[id$='-firstname']").value);
    data.last_name = trim(form.querySelector("[id$='-lastname']").value);
    // data.phone = trim(form.querySelector("[id$='-phone']").value).replace(
    //   /^0/,
    //   "+373"
    // );
    data.phone = "+37369644610";
    data.email = trim(form.querySelector("[id$='-email']").value);
    data.shipping = trim(form.querySelector("#shipping-cost").value);

    var mdInputs = Array.from(form.querySelectorAll("#delivery-md-box input"));
    var cityInputs = Array.from(
      form.querySelectorAll("#delivery-city-box input")
    );
    if (mdInputs.length) {
      data.delivery_method = "COUNTRY";
    } else if (cityInputs.length) {
      data.delivery_method = "CITY";
    } else {
      data.delivery_method = "PICKUP";
      data.pickup_address = document.querySelector('#pick-up-address-select').options[document.querySelector('#pick-up-address-select').selectedIndex].value;
    }
    if (data.delivery_method !== "PICKUP") {
      mdInputs.concat(cityInputs).forEach(function (el) {
        data[el.id] = trim(el.value);
      });
    }

    data.note =
      trim(form.querySelector("#delivery-form-note").value) +
      " " +
      trim(form.querySelector("[id$='-phone']").value);
    // data.shipping_lines.price = 40;
    // data.total_price = 9999;
    // data.total_shipping_price_set.shop_money.amount = 100;

    return data;
  }

  function switchSubmitBtnToDefaultState() {
    removeClass(btnSubmit, "btn--disabled");
    btnSubmit.value = btnValue;
  }

  function addClass(el, className) {
    if (el.classList) {
      el.classList.add(className);
    } else {
      var current = el.className,
        found = false;
      var all = current.split(" ");
      for (var i = 0; i < all.length, !found; i++) found = all[i] === className;
      if (!found) {
        if (current === "") el.className = className;
        else el.className += " " + className;
      }
    }
  }

  function removeClass(el, className) {
    if (el.classList) el.classList.remove(className);
    else
      el.className = el.className.replace(
        new RegExp(
          "(^|\\b)" + className.split(" ").join("|") + "(\\b|$)",
          "gi"
        ),
        " "
      );
  }

  function hasClass(el, className) {
    if (el.classList) return el.classList.contains(className);
    else
      return new RegExp("(^| )" + className + "( |$)", "gi").test(el.className);
  }

  function trim(str) {
    return str.replace(/^\s+|\s+$/g, "");
  }

  function validateEmail(email) {
    var re =
      /^(([^<>()[\]\.,;:\s@\"]+(\.[^<>()[\]\.,;:\s@\"]+)*)|(\".+\"))@(([^<>()[\]\.,;:\s@\"]+\.)+[^<>()[\]\.,;:\s@\"]{2,})$/i;
    return re.test(String(email).toLowerCase());
  }
  function validateEmailInput(input) {
    if (!input.dataset.blurredOnce) {
      return;
    }
    var inputContainer = input.parentNode;
    var errorEl = inputContainer.querySelector("small");
    if (!validateEmail(input.value)) {
      if (!errorEl) {
        errorEl = document.createElement("small");
        errorEl.classList.add("error-label");
        errorEl.innerText = "Неверный E-mail";
        input.insertAdjacentElement("afterend", errorEl);
      }
    } else {
      if (errorEl) {
        inputContainer.removeChild(errorEl);
      }
    }
  }

  function getScrollbarWidth() {
    var scrollDiv = document.createElement("div");
    scrollDiv.style.cssText =
      "width: 99px; height: 99px; overflow: scroll; position: absolute; top: -9999px;";
    document.body.appendChild(scrollDiv);
    var scrollbarSize = scrollDiv.offsetWidth - scrollDiv.clientWidth;
    document.body.removeChild(scrollDiv);
    return scrollbarSize;
  }

  function showCheckoutError(msg) {
    var body = document.body;
    var closeBtn = document.querySelector(".cart-error-popup__close");

    body.classList.add("popup-error-visible");
    body.style.paddingRight = `${getScrollbarWidth()}px`;
    // var el = btnSubmit.parentNode.querySelector("small");
    // var locale = window.Shopify.locale;
    // if (!el) {

    //   el = document.createElement("small");
    //   el.classList.add("error-label");
    //   el.innerText = `${
    //     locale === "ro"
    //       ? "Verificați numărul de telefon"
    //       : "Проверьте номер телефона"
    //   }`;
    //   btnSubmit.insertAdjacentElement("afterend", el);
    // } else {
    //   el.innerText = msg;
    // }

    closeBtn.addEventListener("click", (e) => {
      e.preventDefault();

      body.classList.remove("popup-error-visible");
      body.style.paddingRight = "";
    });
  }

  function hideCheckoutError() {
    var container = btnSubmit.parentNode;
    var errEl = container.querySelector("small");
    if (errEl) {
      container.removeChild(errEl);
    }
  }

  function validateCheckout() {
    // if (!validateEmail(emailInput.value)) {
    //   return false;
    // }

    for (var i = 0; i < inputs.length; i++) {
      var val = trim(inputs[i].value);
      if (!val.length) {
        return false;
      }
    }

    return true;
  }
})();
